import { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../../axios/axiosInstance";
import { getUser } from "../../../redux/slices/AuthUser";

const POLL_INTERVAL = 30000; // 30 seconds — lighter than the inbox poll

export const useUnreadCount = () => {
  const userId = useSelector(getUser)?.id;
  const [count, setCount] = useState(0);
  const pollRef = useRef(null);

  const fetchCount = useCallback(async () => {
    if (!userId) return;
    try {
      const response = await axiosInstance.get("/messages/conversations");
      const conversations = response.data.conversations || [];
      // Backend returns unreadCount per conversation (already resolved for the current user)
      const total = conversations.reduce(
        (sum, conv) => sum + (conv.unreadCount || 0),
        0
      );
      setCount(total);
    } catch {
      // Silently fail — this is a non-critical UI enhancement
    }
  }, [userId]);

  useEffect(() => {
    fetchCount();
    pollRef.current = setInterval(fetchCount, POLL_INTERVAL);
    return () => clearInterval(pollRef.current);
  }, [fetchCount]);

  return count;
};
